import React, {useEffect, useState} from 'react';
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Invite.css";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import M from "materialize-css";

import banner1 from "../logo.svg"
import { API_URL, numberWithCommas, THEME_COLOR } from '../constant';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import jwt  from 'jsonwebtoken';
import HeaderBack from '../layout/HeaderBack';
import gift from "../images/icon/giftbox.svg"
import { Button, Stack, TextField } from '@mui/material';

const Invite = ()=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [memberCode, setMemberCode] = useState("");
    useEffect(()=>{
        setMemberCode(jwt.decode(token));
    },[]);

    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Invite"/>
            <div className='invite-body'>
                <div style={{marginTop:"30px"}}>
                    <img src={gift} width={200} height={230}/>
                </div>
                <p>Share your referral code to your friend and get free <strong>200 points</strong>. Redeem your point and get our exclusive item or any other reward.</p>
                <div style={{textAlign:"left",border:"1px solid gray", padding:"10px", borderRadius:"10px"}}>
                    <div className='invite-header'>Referral Code</div>
                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                    >
                        <span className="invite-code">{memberCode.UserName}</span>
                        <CopyToClipboard text={`https://shop.moorlife.id/${memberCode.UserName}`}
                            onCopy={() => toast.success("copied to clipboard")}>
                            <Button variant="contained" className={THEME_COLOR}>Copy</Button>
                        </CopyToClipboard>
                    </Stack>
                    <hr />
                    <p style={{fontSize:"10pt"}}>
                        The point will be automatically added to your account after your friend successfully registered using your referral code and already activated their account.
                    </p>
                </div>
            </div>
        </React.StrictMode>
    );
}


export default Invite;